import React, { useMemo, useState } from 'react';
import DataGrid, { Lookup, Column, Selection, Paging, FilterRow, Scrolling, Editing } from 'devextreme-react/data-grid';
import DropDownBox from 'devextreme-react/drop-down-box';
import { Popup } from 'devextreme-react/popup';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import { TextBox } from 'devextreme-react';
import IClient from "../../models/IClient";
import { Button } from 'devextreme-react/button';
import { FormListBase, FormListBaseTab } from '../base';
import { SelectBox } from 'devextreme-react';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import ScrollView from 'devextreme-react/scroll-view';
import useLookUpBase from '../../components/selectbox/LookupBase';
import Guid from "../../models/Guid";
import GestionClient from '../gestion-client/gestionclient';
import './gestion-fusion-clients.css';

export default function GestionFusionClients() {
  const clientFormDataSource = useCustomDataSource<IClient, IClient>({ path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list" });
  const { selectedDataRow: selectedClient, setSelectedDataRow, setIsFieldModifier, mode } = clientFormDataSource;
  const { editorOptions: clientDeEditorOption, PopupGestion: PopupGestionClientDe } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'client', setDataRow: () => setDataRow("idClient"), showClear: mode !== Mode.Lecture });
  const { editorOptions: clientVersEditorOption, PopupGestion: PopupGestionClientVers } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'client', setDataRow: () => setDataRow("idClient"), showClear: mode !== Mode.Lecture });
  const { editorOptions: categoriesClientEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'categorieclient', setDataRow: () => setDataRow("idCategorieClient"), showClear: mode !== Mode.Lecture, titre: "Gestion d'une catégorie de client" });
  // const { editorOptions: provincesEditorOption } = useLookUpBase({ isModeModifier: isModeModifier, controllerName: 'province', setDataRow: () => setDataRow("idProvince"), showClear: isModeModifier });
  const [clientDeDataSourceIndex, setClientDeDataSourceIndex] = useState(null);
  const [clientDeDataSource, setClientDeDataSource] = useState<IClient>();
  const [clientDeError, setClientDeError] = useState(false);
  const [clientVersDataSourceIndex, setClientVersDataSourceIndex] = useState(null);
  const [clientVersDataSource, setClientVersDataSource] = useState<IClient>();
  const [clientVersError, setClientVersError] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(true);
  // const [fusions, setFusions] = useState([]);
  const [fusions, setFusions] = useState<Array<{ de?: IClient; vers?: IClient }>>([]);
  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IClient) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }
  
  // const gridColumns = ['ClientName', 'Adresse', 'Ville', 'Code postal', 'Province', 'Téléphone 1', 'Téléphone 2', 'Portable'];
  const nomClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.nom
    };
  }, [clientDeDataSource]);
  const adresseClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.adresse
    };
  }, [clientDeDataSource]);
  const villeClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.ville
    };
  }, [clientDeDataSource]);
  const provinceClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.idProvince
    };
  }, [clientDeDataSource]);
  const paysClientDeOptions = useMemo(() => {
    return {
      text: 'Canada'
    };
  }, [clientDeDataSource]);
  const codePostalClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.codePostal
    };
  }, [clientDeDataSource]);
  const telephoneClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.telephone1
    };
  }, [clientDeDataSource]);
  const courrielClientDeOptions = useMemo(() => {
    return {
      text: clientDeDataSource?.email
    };
  }, [clientDeDataSource]);

  const dropdownOptions = useMemo(() => {
    return {
      width: 1000
    };
  }, []);

  const nomClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.nom
    };
  }, [clientVersDataSource]);
  const adresseClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.adresse
    };
  }, [clientVersDataSource]);
  const villeClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.ville
    };
  }, [clientVersDataSource]);
  const provinceClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.idProvince
    };
  }, [clientVersDataSource]);
  const paysClientVersOptions = useMemo(() => {
    return {
      text: 'Canada'
    };
  }, [clientVersDataSource]);
  const codePostalClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.codePostal
    };
  }, [clientVersDataSource]);
  const telephoneClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.telephone1
    };
  }, [clientVersDataSource]);
  const courrielClientVersOptions = useMemo(() => {
    return {
      text: clientVersDataSource?.email
    };
  }, [clientVersDataSource]);

  const [gridBoxValue, setGridBoxValue] = useState([3]);
  const [isClientDeGridBoxOpened, setIsClientDeGridBoxOpened] = useState(false);
  const [isClientVersGridBoxOpened, setIsClientVersGridBoxOpened] = useState(false);

  const syncDataGridSelection = (e: any) => {
    setGridBoxValue(e.value);
    console.log(e)
    if (e.value === null) {
      setClientDeDataSource(undefined);
      setClientVersDataSource(undefined);
    }
  }

  const dataClientDeGridOnSelectionChanged = (e: any) => {
    console.log(e.selectedRowKeys)
    setGridBoxValue(e.selectedRowKeys);
    setIsClientDeGridBoxOpened(false);
  }
  const dataClientVersGridOnSelectionChanged = (e: any) => {
    console.log(e.selectedRowKeys)
    setGridBoxValue(e.selectedRowKeys);
    setIsClientVersGridBoxOpened(false);
  }


  const onClientDeGridBoxOpened = (e: any) => {
    if (e.name === 'opened') {
      setIsClientDeGridBoxOpened(e.value);
    }
  }
  const onClientVersGridBoxOpened = (e: any) => {
    if (e.name === 'opened') {
      setIsClientVersGridBoxOpened(e.value);
    }
  }

  const onSelectClientDe = (e: any) => {
    console.log(e)
    if (e.data) {
      setClientDeDataSource(e.data)
      setGridBoxValue(e.value);
      setIsClientDeGridBoxOpened(false);
      setClientDeError(false);
    }
  }
  const onSelectClientVers = (e: any) => {
    console.log(e)
    if (e.data) {
      setClientVersDataSource(e.data)
      setGridBoxValue(e.value);
      setIsClientVersGridBoxOpened(false);
      setClientVersError(false);
    }
  }

  const gridBoxDisplayExpr = (item: any) => {
    // const gridBoxDisplayExpr = (item: { nom: any; prenom: any; }) => {
    if (item) {
      if (item.nom || item.prenom)
        return `${item.nom} ${item.prenom}`;
      else if (item.adresse)
        return `${item.adresse} ${item.codePostal}`;
    }
    return '';
  }

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IClient) => {
      return { ...prev, [e]: item.id }
    })
  }

  const dataClientDeGridRender = () => {
    return (
      <DataGrid
        // dataSource={clientFormDataSource.dataSource._items}
        dataSource={clientDeEditorOption.dataSource}
        // columns={gridColumns}
        hoverStateEnabled={true}
        selectedRowKeys={gridBoxValue}
        onSelectionChanged={dataClientDeGridOnSelectionChanged}
        onCellClick={onSelectClientDe}
      // height="100%"
      >
        <Column dataField="nom" dataType="string"></Column>
        <Column dataField="prenom" dataType="string" caption='Prénom'></Column>
        <Column dataField="province" dataType="string"></Column>
        <Column dataField="adresse" dataType="string"></Column>
        <Column dataField="ville" dataType="string"></Column>
        <Column dataField="codePostal" dataType="string"></Column>
        <Column dataField="telephone1" dataType="string" caption='Téléphone 1'></Column>
        <Column dataField="idCategorieClient" dataType="string" caption='Catégorie'>
          <Lookup {...categoriesClientEditorOption} />
        </Column>
        <Column dataField="noChasseur" dataType="string" caption='No. Membre'></Column>
        <Column dataField="carteCreditExp" dataType="string" caption='Exp.'></Column>
        <Selection mode="single" />
        <FilterRow visible={true} />
      </DataGrid>
    );
  }

  const dataClientVersGridRender = () => {
    return (
      <DataGrid
        // dataSource={clientFormDataSource.dataSource._items}
        dataSource={clientVersEditorOption.dataSource}
        // columns={gridColumns}
        hoverStateEnabled={true}
        selectedRowKeys={gridBoxValue}
        onSelectionChanged={dataClientVersGridOnSelectionChanged}
        onCellClick={onSelectClientVers}
      // height="100%"
      >
        <Column dataField="nom" dataType="string"></Column>
        <Column dataField="prenom" dataType="string" caption='Prénom'></Column>
        <Column dataField="province" dataType="string"></Column>
        <Column dataField="adresse" dataType="string"></Column>
        <Column dataField="ville" dataType="string"></Column>
        <Column dataField="codePostal" dataType="string"></Column>
        <Column dataField="telephone1" dataType="string" caption='Téléphone 1'></Column>
        <Column dataField="idCategorieClient" dataType="string" caption='Catégorie'>
          <Lookup {...categoriesClientEditorOption} />
        </Column>
        <Column dataField="noChasseur" dataType="string" caption='No. Membre'></Column>
        <Column dataField="carteCreditExp" dataType="string" caption='Exp.'></Column>
        <Selection mode="single" />
        <FilterRow visible={true} />
      </DataGrid>
    );
  }

  const onClickFusion = () => {
    if (!clientDeDataSource)
      setClientDeError(true);
    if (!clientVersDataSource)
      setClientVersError(true);
    if (!clientDeDataSource || !clientVersDataSource)
      return;

    if (clientDeDataSource == clientVersDataSource ||
      fusions.some(e => e.de == clientDeDataSource && e.vers == clientVersDataSource)) {
      console.log('Ces clients sont déja présents dans la liste');
      return;
    }

    const updatedFusions = [...fusions, { de: clientDeDataSource, vers: clientVersDataSource }];
    setFusions(updatedFusions);
  }

  const appliquer = () => {
    if (window.confirm("Êtes-vous sûre ?")) {
      setClientDeDataSource(undefined);
      setClientVersDataSource(undefined);
    }
  }
  const annuler = () => {
    setClientDeDataSource(undefined);
    setClientVersDataSource(undefined);
    setFusions([]);
    setIsPopupVisible(false);
  }

  const renderInfoDe = (data: any) => {
    if (data.data) {
      if (data.data.de.nom || data.data.de.prenom)
        return `${data.data.de.nom} ${data.data.de.prenom}`;
      else if (data.data.de.adresse)
        return `${data.data.de.adresse} ${data.data.de.codePostal}`;
    }
    return '';
  }

  const renderInfoVers = (data: any) => {
    if (data.data) {
      if (data.data.vers.nom || data.data.vers.prenom)
        return `${data.data.vers.nom} ${data.data.vers.prenom}`;
      else if (data.data.vers.adresse)
        return `${data.data.vers.adresse} ${data.data.vers.codePostal}`;
    }
    return '';
  }

  return <Popup
    visible={isPopupVisible}
    // visible={this.state.popupVisible}
    // onHiding={this.hideInfo}
    dragEnabled={true}
    resizeEnabled={true}
    hideOnOutsideClick={true}
    showCloseButton={false}
    showTitle={true}
    dragOutsideBoundary={true}
    title="Fusionner des clients"
    container=".dx-viewport"
    width={1000}
    height={600}
  >
    <ScrollView width='100%' height='100%'>
      {/* <FormListBase data={clientFormDataSource}> */}
      {/* <FormListBaseTab> */}
      <PopupGestionClientDe onSelectionchanged={(i) => onSelectionchanged(i, 'idpermission')}>
        <GestionClient isModeSelection={true} />
      </PopupGestionClientDe>
      <PopupGestionClientVers onSelectionchanged={(i) => onSelectionchanged(i, 'idpermission')}>
        <GestionClient isModeSelection={true} />
      </PopupGestionClientVers>
      {/* <TabItem title="Liste des clients à fusionner"> */}
      <div style={{ display: "flex" }}>
        <div style={{ width: "70%" }}>
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem colCount={3}>
              <SimpleItem key={"type-message"}>
                <Label text={"Fusionner"} />
                <DropDownBox
                  className={`${clientDeError && 'incomplete'}`}
                  value={clientDeDataSource}
                  opened={isClientDeGridBoxOpened}
                  valueExpr="ID"
                  deferRendering={false}
                  // width={1000}
                  displayExpr={() => gridBoxDisplayExpr(clientDeDataSource)}
                  placeholder="Sélectionner un client…"
                  showClearButton={true}
                  dataSource={clientDeEditorOption.dataSource}
                  onValueChanged={syncDataGridSelection}
                  onOptionChanged={onClientDeGridBoxOpened}
                  dropDownOptions={dropdownOptions}
                  contentRender={dataClientDeGridRender}
                />
                {/* <SelectBox items={[]} width={150} /> */}
              </SimpleItem>
              <SimpleItem key={"type-message2"}>
                <Label text={"avec"} />
                <DropDownBox
                  className={`${clientVersError && 'incomplete'}`}
                  value={clientVersDataSource}
                  opened={isClientVersGridBoxOpened}
                  valueExpr="ID"
                  deferRendering={false}
                  // width={1000}
                  displayExpr={() => gridBoxDisplayExpr(clientVersDataSource)}
                  placeholder="Sélectionner un client…"
                  showClearButton={true}
                  dataSource={clientVersEditorOption.dataSource}
                  onValueChanged={syncDataGridSelection}
                  onOptionChanged={onClientVersGridBoxOpened}
                  dropDownOptions={dropdownOptions}
                  contentRender={dataClientVersGridRender}
                />
              </SimpleItem>
              <SimpleItem>
                <Button
                  style={{ marginLeft: '20px' }}
                  text="Ajouter à la fusion"
                  type="normal"
                  stylingMode="contained"
                  onClick={onClickFusion}
                // onClick={this.onClick}
                />
              </SimpleItem>
            </GroupItem>
            <GroupItem>
              <DataGrid
                showBorders={true}
                allowColumnResizing={true}
                dataSource={fusions}
              >
                <Editing
                  mode="row"
                  allowDeleting={true}
                />
                <Column dataField={'de.nom'} caption={"Remplacer"} cellRender={renderInfoDe} />
                <Column dataField={'vers.nom'} caption={"Par"} cellRender={renderInfoVers} />
              </DataGrid>
            </GroupItem>
          </Form>
        </div>
        <div style={{ width: "30%" }}>
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={clientDeDataSource || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem caption={"Informations du client 1"}>
              <SimpleItem cssClass='nopadding' key={"frm-nom"} dataField={clientDeDataSource?.nom || ''} editorOptions={nomClientDeOptions}>
                <Label text={"Nom"} />
                {/* <TextBox defaultValue={gridBoxValue['ClientName']} /> */}
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"adresse"} dataField={clientDeDataSource?.adresse || ''} editorOptions={adresseClientDeOptions}>
                <Label text={"Adresse"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"ville"} dataField={clientDeDataSource?.ville || ''} editorOptions={villeClientDeOptions} >
                <Label text={"Ville"} />
              </SimpleItem>
              {/* <SimpleItem cssClass='nopadding' key={"province"} dataField={clientDeDataSource?.idProvince.toString() || Guid.empty.toString()} editorOptions={provinceClientDeOptions} >
                <Label text={"Province"} />
              </SimpleItem> */}
              <SimpleItem cssClass='nopadding' key={"pays"} dataField={'Canada'} editorOptions={paysClientDeOptions} >
                <Label text={"Pays"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"code-postal"} dataField={clientDeDataSource?.codePostal || ''} editorOptions={codePostalClientDeOptions} >
                <Label text={"Code postal"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"telephone"} dataField={clientDeDataSource?.telephone1 || ''} editorOptions={telephoneClientDeOptions} >
                <Label text={"Téléphone"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"email"} dataField={clientDeDataSource?.email || ''} editorOptions={courrielClientDeOptions} >
                <Label text={"Courriel"} />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption={"Informations du client 2"}>
              <SimpleItem cssClass='nopadding' key={"frm-nom"} dataField={clientVersDataSource?.nom || ''} editorOptions={nomClientVersOptions}>
                <Label text={"Nom"} />
                {/* <TextBox defaultValue={gridBoxValue['ClientName']} /> */}
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"adresse"} dataField={clientVersDataSource?.adresse || ''} editorOptions={adresseClientVersOptions}>
                <Label text={"Adresse"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"ville"} dataField={clientVersDataSource?.ville || ''} editorOptions={villeClientVersOptions} >
                <Label text={"Ville"} />
              </SimpleItem>
              {/* <SimpleItem cssClass='nopadding' key={"province"} dataField={clientVersDataSource?.idProvince.toString() || ''} editorOptions={provinceClientVersOptions} >
                <Label text={"Province"} />
              </SimpleItem> */}
              <SimpleItem cssClass='nopadding' key={"pays"} dataField={'Canada'} editorOptions={paysClientVersOptions} >
                <Label text={"Pays"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"code-postal"} dataField={clientVersDataSource?.codePostal || ''} editorOptions={codePostalClientVersOptions} >
                <Label text={"Code postal"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"telephone"} dataField={clientVersDataSource?.telephone1 || ''} editorOptions={telephoneClientVersOptions} >
                <Label text={"Téléphone"} />
              </SimpleItem>
              <SimpleItem cssClass='nopadding' key={"email"} dataField={clientVersDataSource?.email || ''} editorOptions={courrielClientVersOptions} >
                <Label text={"Courriel"} />
              </SimpleItem>
              <GroupItem>
                <Button
                  // style={{ marginLeft: '20px' }}
                  text="Appliquer"
                  type="normal"
                  stylingMode="contained"
                  onClick={appliquer}
                />
                <Button
                  style={{ marginLeft: '20px' }}
                  text="Annuler"
                  type="normal"
                  stylingMode="contained"
                  onClick={annuler}
                />
              </GroupItem>
            </GroupItem>
          </Form>
        </div>
      </div >
      <div style={{ display: "flex" }}>
        <div style={{ width: "100%" }}>
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem colCount={3}>
              <GroupItem colCount={2}>
                <SimpleItem>
                  <Label text={"Entreprise"} />
                </SimpleItem>
                <SimpleItem>
                  <Label text={"Espace Tonik"} />
                </SimpleItem>
              </GroupItem>
              <GroupItem colCount={2}>
                <SimpleItem>
                  <Label text={"Utilisateur"} />
                </SimpleItem>
                <SimpleItem>
                  <Label text={"Administrateur Administrateur"} />
                </SimpleItem>
              </GroupItem>
              <GroupItem colCount={2}>
                <SimpleItem>
                  <Label text={"Poste"} />
                </SimpleItem>
                <SimpleItem>
                  <Label text={"Aucun"} />
                </SimpleItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </div >
      </div >
      {/* </TabItem > */}
      {/* </FormListBaseTab > */}
      {/* </FormListBase > */}
    </ScrollView >
  </Popup >
}
